const reviewFieldWrapperTypes = {
  text: "text",
  fileUpload: "fileUpload",
  locationPicker: "locationPicker",
};

export default reviewFieldWrapperTypes;
